module.exports = __webpack_public_path__ + "media/markers/generic_blu-f737db82.svg";